// ============================================================
// Cart Drawer + Universal Add-to-Cart Handler
// Merge logic now runs in TWO places: inside the drawer, and
// directly on the real /cart page — so bundles stay merged no
// matter how a customer arrives at their cart.
// ============================================================

var CartDrawer = {
  el: null,
  body: null,
  footer: null,

  init: function () {
    this.el = document.getElementById('cart-drawer');
    this.body = document.getElementById('cart-drawer-body');
    this.footer = document.getElementById('cart-drawer-footer');
    if (!this.el) return;

    var overlay = document.getElementById('cart-drawer-overlay');
    var closeBtn = document.getElementById('cart-drawer-close');
    var cartIcon = document.getElementById('cart-icon-link');

    if (overlay) overlay.addEventListener('click', this.close.bind(this));
    if (closeBtn) closeBtn.addEventListener('click', this.close.bind(this));
    if (cartIcon) {
      cartIcon.addEventListener('click', function (e) {
        e.preventDefault();
        CartDrawer.refresh();
        CartDrawer.open();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') CartDrawer.close();
    });

    // Handle "Remove" links on NON-bundle items, wherever they
    // appear — inside the drawer, or on the real /cart page.
    document.addEventListener('click', function (e) {
      var link = e.target.closest('.cart-remove');
      if (!link) return;
      var insideDrawer = CartDrawer.body && CartDrawer.body.contains(link);
      var onRealPage = !insideDrawer && link.closest('.cart-list');
      if (!insideDrawer && !onRealPage) return;

      e.preventDefault();
      var jsUrl = link.href.replace('/cart/change', '/cart/change.js');
      fetch(jsUrl).then(function () {
        if (insideDrawer) {
          CartDrawer.refresh();
        } else {
          window.location.reload();
        }
      });
    });
  },

  open: function () {
    if (this.el) this.el.setAttribute('aria-hidden', 'false');
  },

  close: function () {
    if (this.el) this.el.setAttribute('aria-hidden', 'true');
  },

  updateHeaderCount: function (count) {
    var cartIcon = document.getElementById('cart-icon-link');
    if (!cartIcon) return;
    var countEl = cartIcon.querySelector('.cart-count');
    if (count > 0) {
      if (!countEl) {
        countEl = document.createElement('span');
        countEl.className = 'cart-count';
        cartIcon.appendChild(countEl);
      }
      countEl.textContent = '(' + count + ')';
    } else if (countEl) {
      countEl.remove();
    }
  },

  refresh: function () {
    var self = this;
    var pageFetch = fetch('/cart').then(function (res) { return res.text(); });
    var countFetch = fetch('/cart.js').then(function (res) { return res.json(); });

    return Promise.all([pageFetch, countFetch]).then(function (results) {
      var html = results[0];
      var cart = results[1];
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var mainContent = doc.querySelector('.main-content');
      if (mainContent && self.body) {
        self.body.innerHTML = mainContent.innerHTML;
        mergeBundleRows(cart.items, self.body, false);
        promoteFooterContent(self.body, self.footer);
      }
      self.updateHeaderCount(cart.item_count);
    }).catch(function (err) {
      console.error('Cart refresh failed', err);
    });
  }
};

// ============================================================
// Move subtotal + checkout button into the fixed footer (drawer only)
// ============================================================

function promoteFooterContent(body, footer) {
  if (!footer) return;
  footer.innerHTML = '';

  var subtotalEl = body.querySelector('form#cartform .h2');
  var checkoutBtn = body.querySelector('form#cartform button[name="checkout"]');

  if (subtotalEl) footer.appendChild(subtotalEl);
  if (checkoutBtn) {
    checkoutBtn.setAttribute('form', 'cartform');
    footer.appendChild(checkoutBtn);
  }
}

// ============================================================
// Merge Top/Bottom(/Dupatta) bundle pieces into one combined
// cart row. Works on any container passed in — the drawer's
// body, OR the real /cart page itself.
// ============================================================

function money(cents) {
  return 'Rs. ' + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

// Accepts an array of line-item keys (2 for Top+Bottom, 3 when
// Dupatta is included) and changes them all in a single atomic
// /cart/update.js call. Using update.js instead of several
// parallel change.js calls avoids a race condition where
// Shopify's cart endpoint can silently drop one of several
// simultaneous changes.
function changeBundleQty(keys, newQty, reloadOnChange) {
  var updates = {};
  keys.forEach(function (k) { updates[k] = newQty; });

  fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ updates: updates })
  }).then(function () {
    if (reloadOnChange) {
      window.location.reload();
    } else {
      CartDrawer.refresh();
    }
  });
}

// ============================================================
// Fetch the mother product's own image (cached per handle) so
// the merged row shows the real "Set" photo, not the Top's.
// ============================================================

var motherImageCache = {};

function getMotherImage(handle) {
  if (motherImageCache[handle]) return motherImageCache[handle];

  var promise = fetch('/products/' + handle + '.js')
    .then(function (res) { return res.json(); })
    .then(function (product) { return product.featured_image || null; })
    .catch(function () { return null; });

  motherImageCache[handle] = promise;
  return promise;
}

function mergeBundleRows(cartItems, root, reloadOnChange) {
  root = root || (CartDrawer && CartDrawer.body);
  if (!root) return;
  var rows = root.querySelectorAll('.cart-list .item');
  if (!rows.length || !cartItems || !cartItems.length) return;

  var groups = {};
  cartItems.forEach(function (item, i) {
    var bundleHandle = item.properties && item.properties._bundle;
    if (!bundleHandle) return;
    // Group by the shared bundle-instance id set at add-to-cart time
    // (so Top/Bottom/Dupatta from the SAME click stay together even
    // though the Dupatta's own variant title doesn't match the
    // age-based Top/Bottom titles). Falls back to variant_title for
    // any older 2-piece bundle line items already sitting in a
    // customer's cart from before this property existed.
    var instanceKey = item.properties._bundle_instance;
    var groupKey = bundleHandle + '|' + (instanceKey || item.variant_title);
    if (!groups[groupKey]) groups[groupKey] = [];
    groups[groupKey].push({ item: item, row: rows[i] });
  });

  Object.keys(groups).forEach(function (groupKey) {
    var pieces = groups[groupKey];
    if (pieces.length < 2) return;

    var topEntry = pieces.filter(function (p) { return p.item.properties._bundle_role === 'Top'; })[0];
    var bottomEntry = pieces.filter(function (p) { return p.item.properties._bundle_role === 'Bottom'; })[0];
    var dupattaEntry = pieces.filter(function (p) { return p.item.properties._bundle_role === 'Dupatta'; })[0];
    if (!topEntry || !bottomEntry || !topEntry.row || !bottomEntry.row) return;
    if (dupattaEntry && !dupattaEntry.row) dupattaEntry = null;

    var primaryRow = topEntry.row;

    bottomEntry.row.style.display = 'none';
    if (dupattaEntry) dupattaEntry.row.style.display = 'none';

    var setName = topEntry.item.product_title.replace(/\s*Top$/i, '');
    var bundleHandle = topEntry.item.properties._bundle;

    // Swap in the mother product's real image instead of the Top's.
    var imgEl = primaryRow.querySelector('.col-image img');
    if (imgEl && bundleHandle) {
      getMotherImage(bundleHandle).then(function (imageUrl) {
        if (imageUrl) {
          imgEl.src = imageUrl;
          imgEl.removeAttribute('srcset');
          imgEl.alt = setName + ' Set';
        }
      });
    }

    var descEl = primaryRow.querySelector('.col-desc .title');
    if (descEl) {
      var breakdown = 'Top: ' + money(topEntry.item.price) + ' &middot; Bottom: ' + money(bottomEntry.item.price);
      if (dupattaEntry) breakdown += ' &middot; Dupatta: ' + money(dupattaEntry.item.price);
      descEl.innerHTML =
        '<a href="' + topEntry.item.url + '">' + setName + ' Set<br>' + topEntry.item.variant_title + '</a>' +
        '<div style="font-size:12px;opacity:0.7;margin-top:4px;">' + breakdown + '</div>';
    }

    var combinedPrice = topEntry.item.price + bottomEntry.item.price + (dupattaEntry ? dupattaEntry.item.price : 0);
    var combinedTotal = topEntry.item.final_line_price + bottomEntry.item.final_line_price + (dupattaEntry ? dupattaEntry.item.final_line_price : 0);

    var priceEl = primaryRow.querySelector('.col-price');
    if (priceEl) {
      priceEl.innerHTML = '<div class="theme-money">' + money(combinedPrice) + '</div>';
    }

    var totalEl = primaryRow.querySelector('.col-total');
    if (totalEl) {
      totalEl.innerHTML = '<div class="theme-money">' + money(combinedTotal) + '</div>';
    }

    var qtyEl = primaryRow.querySelector('.col-quantity');
    if (qtyEl) {
      var qty = topEntry.item.quantity;
      var pieceKeys = [topEntry.item.key, bottomEntry.item.key];
      if (dupattaEntry) pieceKeys.push(dupattaEntry.item.key);

      qtyEl.innerHTML =
        '<div class="qty-selector">' +
          '<button type="button" class="qty-btn minus-btn cart-drawer-set-minus" data-direction="-">-</button>' +
          '<input class="input quantity" type="number" readonly value="' + qty + '">' +
          '<button type="button" class="qty-btn plus-btn cart-drawer-set-plus" data-direction="+">+</button>' +
        '</div>' +
        '<div style="margin-top:6px;"><a href="#" class="cart-drawer-set-remove">Remove</a></div>';
      qtyEl.querySelector('.cart-drawer-set-plus').addEventListener('click', function () {
        changeBundleQty(pieceKeys, qty + 1, reloadOnChange);
      });
      qtyEl.querySelector('.cart-drawer-set-minus').addEventListener('click', function () {
        changeBundleQty(pieceKeys, Math.max(0, qty - 1), reloadOnChange);
      });
      qtyEl.querySelector('.cart-drawer-set-remove').addEventListener('click', function (e) {
        e.preventDefault();
        changeBundleQty(pieceKeys, 0, reloadOnChange);
      });
    }
  });
}

// ============================================================
// Merge on the REAL /cart page (not just inside the drawer)
// ============================================================

function initRealCartPage() {
  var path = window.location.pathname.replace(/\/$/, '');
  var isCartPage = path === '/cart' || path.endsWith('/cart');
  if (!isCartPage) return;

  var cartListEls = document.querySelectorAll('.cart-list');
  var realCartList = null;
  cartListEls.forEach(function (el) {
    if (!el.closest('#cart-drawer')) realCartList = el;
  });
  if (!realCartList) return;

  fetch('/cart.js')
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      mergeBundleRows(cart.items, document, true);
    })
    .catch(function (err) {
      console.error('Real cart page merge failed', err);
    });
}

// ============================================================
// Bundle detection for Add-to-Cart
//
// IMPORTANT: the dupatta product is only ever requested when the
// caller tells us this product actually HAS a dupatta option
// (wantDupatta). Products without one — Shalimar, Rana, etc. —
// make exactly the same two requests they always have, so their
// pages behave identically to before this feature existed.
// ============================================================

var bundleCache = {};

function getBundleForHandle(handle, wantDupatta) {
  var cacheKey = handle + (wantDupatta ? '|d' : '');
  if (bundleCache[cacheKey]) return bundleCache[cacheKey];

  var requests = [
    fetch('/products/' + handle + '-top.js'),
    fetch('/products/' + handle + '-bottom.js')
  ];
  if (wantDupatta) {
    requests.push(fetch('/products/' + handle + '-dupatta.js'));
  }

  var promise = Promise.all(requests).then(function (results) {
    var topRes = results[0];
    var bottomRes = results[1];
    var dupattaRes = results[2];
    if (!topRes.ok || !bottomRes.ok) return null;

    return Promise.all([topRes.json(), bottomRes.json()]).then(function (data) {
      var topProduct = data[0];
      var bottomProduct = data[1];
      var topByLabel = {};
      topProduct.variants.forEach(function (v) { topByLabel[v.title] = v.id; });
      var bottomByLabel = {};
      bottomProduct.variants.forEach(function (v) { bottomByLabel[v.title] = v.id; });

      var result = { topByLabel: topByLabel, bottomByLabel: bottomByLabel, dupattaVariantId: null };

      if (!dupattaRes || !dupattaRes.ok) return result;

      return dupattaRes.json().then(function (dupattaProduct) {
        if (dupattaProduct.variants && dupattaProduct.variants[0]) {
          result.dupattaVariantId = dupattaProduct.variants[0].id;
        }
        return result;
      }).catch(function () { return result; });
    });
  }).catch(function () { return null; });

  bundleCache[cacheKey] = promise;
  return promise;
}

// ============================================================
// Universal Add-to-Cart interception
// ============================================================

function initAddToCart() {
  var forms = document.querySelectorAll('form[action="/cart/add"]');

  forms.forEach(function (form) {
    var idField = form.querySelector('[name="id"]');
    var qtyField = form.querySelector('[name="quantity"]');
    var submitBtn = form.querySelector('button[type="submit"], button[name="add"]');
    if (!idField || !submitBtn) return;
    if (form.dataset.cartBound) return;
    form.dataset.cartBound = 'true';

    var productHandle = form.dataset.productHandle || window.__bundleCheckHandle;
    var productId = form.dataset.productId || window.__bundleCheckProductId;

    var freshBtn = submitBtn.cloneNode(true);
    submitBtn.parentNode.replaceChild(freshBtn, submitBtn);
    freshBtn.type = 'button';

    freshBtn.addEventListener('click', async function (e) {
      e.preventDefault();
      freshBtn.disabled = true;

      var selectedVariantId = idField.value;
      var selectedQty = (qtyField && parseInt(qtyField.value, 10)) || 1;
      var ageLabel = form.dataset.variantTitle || null;
      var includeDupatta = false;
      var productHasDupattaOption = false;

      if (productId) {
        var jsonEl = document.getElementById('ProductJson-' + productId);
        if (jsonEl) {
          try {
            var currentProduct = JSON.parse(jsonEl.textContent);

            // Does this product even offer a dupatta choice? We read
            // its option names from data already on the page — no
            // network request, so nothing happens on products that
            // don't have one.
            var optionNames = currentProduct.options || [];
            optionNames.forEach(function (opt) {
              var name = (typeof opt === 'string') ? opt : (opt && opt.name);
              if (name && /dupatta/i.test(name)) productHasDupattaOption = true;
            });

            var match = currentProduct.variants.find(function (v) {
              return String(v.id) === String(selectedVariantId);
            });
            if (match) {
              // option1 is always the FIRST option's value regardless
              // of how many options a product has, so this stays
              // correct both for simple bundles (age only) and for
              // bundles with a second WITH/WITHOUT Dupatta option.
              ageLabel = match.option1 || match.title;

              if (productHasDupattaOption) {
                // Check every option value for a "with dupatta" style
                // choice, so it works no matter which option position
                // the dupatta choice sits in.
                [match.option1, match.option2, match.option3].forEach(function (val) {
                  if (!val) return;
                  var v = String(val).trim();
                  if (/dupatta/i.test(v) && /^with\s/i.test(v)) includeDupatta = true;
                });
              }
            }
          } catch (err) { /* fall back to staticVariantTitle */ }
        }
      }

      var items;
      // Only ask for the dupatta product when this product actually
      // has that option AND the customer chose "with".
      var bundle = productHandle ? await getBundleForHandle(productHandle, includeDupatta) : null;

      if (bundle && ageLabel && bundle.topByLabel[ageLabel] && bundle.bottomByLabel[ageLabel]) {
        var bundleInstanceId = Date.now() + '-' + Math.random().toString(36).slice(2);
        items = [
          { id: bundle.topByLabel[ageLabel], quantity: selectedQty, properties: { _bundle: productHandle, _bundle_role: 'Top', _bundle_instance: bundleInstanceId } },
          { id: bundle.bottomByLabel[ageLabel], quantity: selectedQty, properties: { _bundle: productHandle, _bundle_role: 'Bottom', _bundle_instance: bundleInstanceId } }
        ];
        if (includeDupatta && bundle.dupattaVariantId) {
          items.push({ id: bundle.dupattaVariantId, quantity: selectedQty, properties: { _bundle: productHandle, _bundle_role: 'Dupatta', _bundle_instance: bundleInstanceId } });
        }
      } else {
        items = [{ id: selectedVariantId, quantity: selectedQty }];
      }

      try {
        var addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        });
        if (!addRes.ok) throw new Error('Add to cart failed');

        await CartDrawer.refresh();
        CartDrawer.open();
      } catch (err) {
        console.error('Add to cart failed', err);
      } finally {
        freshBtn.disabled = false;
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  CartDrawer.init();
  initAddToCart();
  initRealCartPage();
});
